<div class="wrapper">
  <ion-grid class="ion-no-padding">
    <ion-row class="bar">
      <ion-col size="2" class="ion-padding-start"
        ><div (click)="onPrevClick(index - 1)" class="arrow">
        <ion-icon [ngClass]="prevActive && index > 0 && ['active', 'pointer']" name="arrow-back-outline"></ion-icon></div
      ></ion-col>
      <ion-col size="8"
        ><div class="ion-text-center no-select">
        <ion-text class="text">{{ index + 1 }} / {{ quantityOfSlides }}</ion-text>
      </div></ion-col
      >
      <ion-col size="2" class="ion-padding-end">
        <div (click)="onNextClick(index + 1)" class="ion-text-right arrow">
          @if (index < quantityOfSlides - 1) {
            <ion-icon
              [ngClass]="nextActive && ['active', 'pointer']"
              name="arrow-forward-outline"
            ></ion-icon>
          } @else {
            <ion-icon [ngClass]="nextActive && ['active', 'pointer']" name="checkmark"></ion-icon>
          }
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
